export default "__VITE_ASSET__4246f43d__"